import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTextInput from "../../../../../CustomComponents/CustomtextInput";
import { useTranslation } from "react-i18next";
import CustomDropdown from "../../../../../CustomComponents/CustomDropDown";
import CustomDatePicker from "../../../../../CustomComponents/CustomDateInput";
import Calender from "../../../../../../assets/images/calender_3x.png";
import { handleAmountInputLimitTo2decimal } from "../../../../../../utils";
import {
  appTheme,
  decimalValidation,
  frequencyDataConverted,
} from "../../../../../../helpers/utils/Utils";
import CustomAllocateFundDropdown from "../../../../../CustomComponents/CustomAllocateFundDropdown";
import { useEffect } from "react";
import { PostRequest } from "../../../../../../network/NetworkUtils";
import { retrieveData } from "../../../../../../utils";
import { EDIT_MANAGE_SAVIGN_V2 } from "../../../../../../network/URLConstants";
import { GetApiHeadersWithBearer } from "../../../../../../network/NetworkUtils";
import { SAVING_CARD_CODE } from "../../../../../../network/URLConstants";

const EditAndRemoveGoals = ({ data, onEdit, isActive , lockedToggle , setIsEditingState}) => {
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const savingsGoalAmount = useSelector((state) => state.savingGoals.Amount);
  const cards = useSelector((state) => JSON.parse(state.userCards));
  const accessToken = useSelector((state) => state.accessToken)
    const goalKeyData = useSelector(
    (state) => state.savingGoalResponseData.goalKey
  );
  const appThemeData = appTheme(kudzuPlusTrue);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [editedValue, setEditedValue] = useState(data.value);
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState("");
  const errorMessages = {
    Amount: "Amount is required",
    AmountSaving: "Installment is required",
    Frequency: "Frequency  type is required",
    Name: "Name is required",
    SavingAmount:"Amount is required"
  };
  const frequecyDataGetting = useSelector((state) => state.frequecyData);
  const accountObj = useSelector((state) => state.accountTypes);
  const [selectedAccountType, setSelectedAccountType] = useState("");
  const [editedFrequency, setEditedFrequency] = useState({});

    useEffect(() => {
      if (setIsEditingState) {
        setIsEditingState(isEditing);  // Pass the state directly to the parent component
      }
    }, [isEditing]);

    const handleSaveForGoalName = async (goalName) => {
      const modifiedData = {
        goalName: goalName,
      };
      const deviceId = await retrieveData("updatedDeviceId");
      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const savingsAccount = cards.find(
        (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
      );
  
      const url = EDIT_MANAGE_SAVIGN_V2(savingsAccount.CardKey, goalKeyData);
      try {
        const response = await PostRequest(url, modifiedData, headers);
        const responseJson = JSON.parse(response);
      } catch (error) {
        console.log(error);
      }
    };

    const handleSaveForAmount = async (targetAmount) => {
      const modifiedData = {
        targetAmount: targetAmount,
      };
      const deviceId = await retrieveData("updatedDeviceId");
      const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
      const savingsAccount = cards.find(
        (account) => account.AccountTypeBit63 == SAVING_CARD_CODE
      );
  
      const url = EDIT_MANAGE_SAVIGN_V2(savingsAccount.CardKey, goalKeyData);
      try {
        const response = await PostRequest(url, modifiedData, headers);
        const responseJson = JSON.parse(response);
      } catch (error) {
        console.log(error);
      }
    };

  const handleSave = () => {
    if (!editedValue) {
      setError(errorMessages[data.type]);
    } else {
      setIsEditing(false);
      dispatch({
        type: "ALLOCATE_FUND",
        payload: { key: data.type, value: editedValue },
      });
       
      if (data.type == "Name") {
        dispatch({
          type: "SAVING_GOALS",
          payload: { key: data.type, value: editedValue },
        });
        
        handleSaveForGoalName(editedValue)
      }

      if (data.type == "Amount") {
        // if (editedValue && !editedValue.includes(".")) {
        //   dispatch({
        //     type: "SAVING_GOALS",
        //     payload: { key: data.type, value: editedValue + ".00" },
        //   });
        // }
        
        
        // else if(editedValue && editedValue.includes(".")){
        //   // const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
        //   const [integerPart] =  editedValue.split(".");
        //   const decimalPart = editedValue.split(".")[1];
        //   if (decimalPart && decimalPart.length === 1) {
        //     dispatch({
        //       type: "SAVING_GOALS",
        //       payload: {
        //         key: "Amount",
        //         value: integerPart.toString().replace("$", "") + `.0${decimalPart}`,
        //       },
        //     });
        //   } else if (integerPart && !decimalPart.length === 2) {
        //     dispatch({
        //       type: "SAVING_GOALS",
        //       payload: { key: data.type, value: editedValue + "00" },
        //     });
        //   }
        //   else {
        //     dispatch({
        //       type: "SAVING_GOALS",
        //       payload: { key: data.type, value: editedValue },
        //     });
        //   }
        
        // }



        // else {
        //   dispatch({
        //     type: "SAVING_GOALS",
        //     payload: { key: data.type, value: editedValue },
        //   });
        // }
        const finalAmountVal = decimalValidation(editedValue)
        dispatch({
          type: "SAVING_GOALS",
          payload: { key: data.type, value: finalAmountVal },
        });
        handleSaveForAmount(editedValue)
      }
      if (data.type == "SavingAmount") {
        const finalAmountVal = decimalValidation(editedValue)
        dispatch({
          type: "SAVING_GOALS",
          payload: { key: data.type, value: finalAmountVal },
        });
      }

      if (data.type == "AmountSaving") {
        // if (editedValue && !editedValue.includes(".")) {
        //   dispatch({
        //     type: "ALLOCATE_FUND",
        //     payload: { key: data.type, value: editedValue + ".00" },
        //   });
        // } else {
        //   dispatch({
        //     type: "ALLOCATE_FUND",
        //     payload: { key: data.type, value: editedValue },
        //   });
        // }
        const finalInstallmentVal = decimalValidation(editedValue)
        dispatch({
          type: "ALLOCATE_FUND",
          payload: { key: data.type, value: finalInstallmentVal },
        });
      }
      if (data.type == "Frequency") {
        dispatch({
          type: "SELECTED_FREQUENCY_VALUE",
          payload: { selectedFrequencyValue: editedFrequency },
        });
      }
    }
  };

  

  const handleOnBlur = (event) => {
    if (!editedValue) {
      setError(errorMessages[data.type]);
    } else if (data.type === "Amount" && editedValue <= 0) {
      setError("Please enter amount ");
    } else if (editedValue && !editedValue.includes(".")) {
      const inputValue = event.target.value;
      const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
      // dispatch({ type: 'SAVING_GOALS', payload: { 'key': "Amount", 'value': formattedAmount.toString().replace('$', '') + '.00' } })
    } else {
      setError("");
    }
  };
  const handleOnBlurInstallment = (event) => {
    if (!editedValue) {
      setError(errorMessages[data.type]);
    } else if (data.type === "Installments" && editedValue <= 0) {
      setError("Please enter amount ");
    } else if (editedValue && !editedValue.includes(".")) {
      const inputValue = event.target.value;
      const formattedAmount = handleAmountInputLimitTo2decimal(inputValue);
      dispatch({
        type: "ALLOCATE_FUND",
        payload: {
          key: "Installments",
          value: formattedAmount.toString().replace("$", "") + ".00",
        },
      });
    } else {
      setError("");
    }
  };
  const setFrequencyFun = (value) => {
    setSelectedAccountType(value);
    dispatch({
      type: "SAVING_GOAL_ACCOUNT_TYPE_OBJ",
      payload: { savingGoalAccountTypeObj: value },
    });
  };

  

  return (
    <>
      {data.value && (
        <div className="flex flex-col justify-center md:mt-12 sm:mt-10 mt-12">
          {!isEditing && (
            <p
              className="pt-5 font-hanken-grotesk text-[var(--subHead-clr)] 
            uppercase lg:text-[13px] md:text-[12px] sm:text-[12px] text-[13px]
            font-[600] tracking-[2px] md:pb-8 pb-4
          "
            >
              {data.title}
            </p>
          )}
          {isEditing ? (
            <>
              {data.type === "Amount" ? (
                <CustomTextInput
                  name={t("amount")}
                  onKeyDown={(event) => {
                    if (event.key === "Enter") {
                      event.preventDefault();
                      event.target.style.opacity = 0.8;
                      setTimeout(() => {
                        event.target.style.opacity = 1;
                      }, 200);
                    }
                  }}
                  value={editedValue}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    const formattedAmount =
                      handleAmountInputLimitTo2decimal(inputValue);
                      if (formattedAmount.length <=10) {
                        setEditedValue(formattedAmount.toString().replace("$", ""));
                      }else{
                        console.log('enter less than 10 ')
                      }
                    if (!formattedAmount) setError("Enter Amount");
                    else if (inputValue <= 0) {
                      setError("Please enter amount greater than 0");
                    } else setError("");
                  }}
                  placeholder={"$ 0"}
                  onBlur={(event) => handleOnBlur(event)}
                  inputWidth="w-full"
                  error={error}
                />
              ) :data.type === "SavingAmount" ? ( 
                <CustomTextInput
                name={t("Saving Amount")}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    event.target.style.opacity = 0.8;
                    setTimeout(() => {
                      event.target.style.opacity = 1;
                    }, 200);
                  }
                }}
                value={editedValue}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  const formattedAmount =
                    handleAmountInputLimitTo2decimal(inputValue);
                    if (formattedAmount.length <=10) {
                      setEditedValue(formattedAmount.toString().replace("$", ""));
                    }else{
                      console.log('enter less than 10 ')
                    }
                  if (!formattedAmount) setError("Enter Amount");
                  else if (inputValue <= 0) {
                    setError("Please enter amount greater than 0");
                  } else setError("");
                }}
                placeholder={"$ 0"}
                onBlur={(event) => handleOnBlur(event)}
                inputWidth="w-full"
                error={error}
              />
              )  : data.type === "TargetDate" ?(
                <>
                 <CustomDatePicker
                    selectedDate={data.value}
                    onDateChange={(date) => setEditedValue(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    //maxDate={''}
                    placeHolder={"Month_Day_Year"}
                    disabledDates={[]}
                    title="Target Date"
                    hrbg="bg-dropdown-sky"
                  />
                </>
              )
              
               : data.type === "AmountSaving" ? (
                <>
                  <CustomTextInput
                    name={t("Amount Saving")}
                     
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        event.target.style.opacity = 0.8;
                        setTimeout(() => {
                          event.target.style.opacity = 1;
                        }, 200);
                      }
                    }}
                    value={editedValue}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      const formattedAmount =
                        handleAmountInputLimitTo2decimal(inputValue);
                        if (formattedAmount.length <= 10) {
                          setEditedValue(formattedAmount.toString().replace("$", ""));
                        }else{
                          console.log('enter less than 10 ')
                        }
                   
                      if (!formattedAmount) setError("Enter Installments");
                      else if (inputValue <= 0) {
                        setError("Please enter Installments greater than 0");
                      } else if (
                        parseFloat(formattedAmount) >
                        parseFloat(savingsGoalAmount)
                      ) {
                        setError(t("The_fund_amount_should_be_less"));
                      } else setError("");
                    }}
                    placeholder={"$ 0"}
                    onBlur={(event) => handleOnBlurInstallment(event)}
                    inputWidth="w-full"
                    error={error}
                  />
                </>
              ) : data.type === "Frequency" ? (
                <CustomDropdown
                  isScroll={false}
                  options={frequecyDataGetting}
                  title="FREQUENCY"
                  onSelect={(option) => {
                    setEditedFrequency(option);
                    // debugger;
                    // dispatch({
                    //   type: "SELECTED_FREQUENCY_VALUE",
                    //   payload: { selectedFrequencyValue: option },
                    // });
                    setEditedValue(option.DisplayText);
                  }}
                  selectedFrequency={editedValue}
                  error={error}
                />
              ) :   data.type === "Name" ? (
                <>
                  <CustomTextInput
                    name={"Savings Goal"}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        event.preventDefault();
                        event.target.style.opacity = 0.8;
                        setTimeout(() => {
                          event.target.style.opacity = 1;
                        }, 200);
                      }
                    }}
                    value={editedValue}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      if (inputValue.length <= 50) {
                        setEditedValue(inputValue);
                      } else{
                        console.log('enter less than 20 characters')
                      }
                      
                      if (!inputValue) setError("Enter Savings Goal");
                      else if (inputValue <= 0) {
                        setError("Please enter Savings Goal");
                      } else setError("");
                    }}
                    placeholder={"Name"}
                    onBlur={(event) => handleOnBlur(event)}
                    inputWidth="w-full"
                    error={error}
                  />
                </>
              ) : null}
              <p
                className="pt-5 font-hanken-grotesk font-[700] cursor-pointer text-[var(--dynamic-save-clr)] lg:text-[16px] md:text-[15px] 
 sm:text-[13px] text-[13px]
 "
                onClick={() => {
                  if (!error) {
                    handleSave();
                  }
                }}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSave();
                }}
              >
                {t("save")}
              </p>
            </>
          ) : (
            <>
              <p
                className="md:mb-6 mb-2 flex flex-row justify-between font-hanken-grotesk font-[700] lg:text-[16px] md:text-[15px] sm:text-[13px] 
 text-[14px] text-[var(--pin-clr)]"
              >
                {data.title === "Amount" ? `$ ${data.value}` : data.value}
                {data.title === "Start" && (
                  <img
                    src={appThemeData.callAcc}
                    alt="Calender"
                    className="w-3 h-3 mr-2 ml-10"
                  />
                )}
              </p>
              <hr className="h-[2px] bg-[var(--hr-color)] border-0 rounded" />
              {
                !lockedToggle && (
                  <p
                  className="pt-5 font-hanken-grotesk font-[700] cursor-pointer text-[var(--buttons-clrs)] lg:text-[16px] md:text-[15px] 
                  sm:text-[13px] text-[13px]
                  "
                  onClick={() => setIsEditing(true)}
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") setIsEditing(true);
                  }}
                >
                  {data.edit}
                </p>
                )
              }

            </>
          )}
        </div>
      )}


    </>
  );
};

export default EditAndRemoveGoals;
